import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export type SemanticSearchAuthStep = "login" | "signup" | "phone_verification";

export interface ISemanticSearchAuthStore {
    activeDrawer: SemanticSearchAuthStep | null;
}

export const semanticSearchAuthSliceInitialState: ISemanticSearchAuthStore = {
    activeDrawer: null
};

export const semanticSearchAuthSlice = createSlice({
    name: "semanticSearchAuth",
    initialState: semanticSearchAuthSliceInitialState,
    reducers: {
        openLoginDrawer: (state) => {
            state.activeDrawer = "login";
        },
        openSignupDrawer: (state) => {
            state.activeDrawer = "signup";
        },
        openPhoneVerificationStep: (state) => {
            state.activeDrawer = "phone_verification";
        },
        setSemanticSearchAuthStep: (state, action: PayloadAction<SemanticSearchAuthStep>) => {
            state.activeDrawer = action.payload;
        },
        closeAuthDrawer: (state) => {
            state.activeDrawer = null;
        }
    }
});

export const {openLoginDrawer, openSignupDrawer, openPhoneVerificationStep, setSemanticSearchAuthStep, closeAuthDrawer} = semanticSearchAuthSlice.actions;
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export type SemanticSearchAuthStep = "login" | "signup" | "phone_verification";

export interface ISemanticSearchAuthStore {
    activeDrawer: SemanticSearchAuthStep | null;
}

export const semanticSearchAuthSliceInitialState: ISemanticSearchAuthStore = {
    activeDrawer: null
};

export const semanticSearchAuthSlice = createSlice({
    name: "semanticSearchAuth",
    initialState: semanticSearchAuthSliceInitialState,
    reducers: {
        openLoginDrawer: (state) => {
            state.activeDrawer = "login";
        },
        openSignupDrawer: (state) => {
            state.activeDrawer = "signup";
        },
        openPhoneVerificationStep: (state) => {
            state.activeDrawer = "phone_verification";
        },
        setSemanticSearchAuthStep: (state, action: PayloadAction<SemanticSearchAuthStep>) => {
            state.activeDrawer = action.payload;
        },
        closeAuthDrawer: (state) => {
            state.activeDrawer = null;
        }
    }
});

export const {openLoginDrawer, openSignupDrawer, openPhoneVerificationStep, setSemanticSearchAuthStep, closeAuthDrawer} = semanticSearchAuthSlice.actions;
